export const redColor = "#cc6666"; // 设置暗红色
export const greenColor = "#66cc66"; // 设置暗绿色
